"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = require("react");
const mainLinkUtils_1 = require("../utils/mainLinkUtils");
const useActiveLink = (links = []) => {
    const [activeLink, setActiveLink] = (0, react_1.useState)(undefined);
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    let foundActive = false;
    for (let i = 0; i < links.length; i++) {
        const link = links[i];
        const isActive = (0, mainLinkUtils_1.isActiveLink)(link, locale);
        if (isActive) {
            foundActive = true;
            if (link === activeLink) {
                break;
            }
            setActiveLink(link);
            break;
        }
    }
    if (!foundActive && activeLink !== undefined) {
        setActiveLink(undefined);
    }
    return activeLink;
};
exports.useActiveLink = useActiveLink;
//# sourceMappingURL=link.hooks.js.map